module.exports = __webpack_public_path__ + "static/media/sf_attraction_zoo.56c69453.jpg";